import { useState } from 'react';
import { Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import styles from './styles.module.scss';

export default function VideoGrid({ content, post, global, customClass = "", pathPrefix }) {
  const [show, setShow] = useState(false);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [activeTitle, setActiveTitle] = useState(null);

  const getYouTubeId = (url) => {
    const match = url.match(/(?:\?v=|\/embed\/|\.be\/)([^\s&]+)/);
    return match ? match[1] : null;
  };

  const handleOpen = (youtubeUrl, title) => {
    const videoId = getYouTubeId(youtubeUrl);
    setActiveVideoId(videoId);
    setActiveTitle(title);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setActiveVideoId(null);
    setActiveTitle(null);
  };
  return (
    <section className={`${styles.root} ${customClass}`}>
        <Container>
        {content ? (
            <div className="mb-4">
            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                {content}
            </SourceFlowText>
            </div>
        ) : ""}

        <Row className="p-md-5 p-2 py-3 rounded-3 m-0">
            {post.map((postItem, index) => (
            <Col md={4} key={index} className="mb-4">
                <Card className="rounded-3 h-100 text-center">
                <div
                    role="button"
                    onClick={() => handleOpen(postItem.video_url, postItem.title)}
                    className="text-decoration-none cursor-pointer"
                >
                    <div className="thumbnail-wrapper rounded-top-3">
                        <SourceFlowImage
                            src={postItem?.thumbnail_image || "/site-assets/images/image-placeholder.webp"}
                            alt={postItem?.title}
                            size="500x"
                            className="thumbnail-img rounded-0 img-fluid"
                        />
                        <img className="play-button" src="/site-assets/images/play-button.png" />
                    </div>
                    
                    <hr />
                    <div className="px-2 pb-2">
                        <SourceFlowImage
                            src={postItem?.logo_image || "/site-assets/images/image-placeholder.webp"}
                            alt={postItem?.title}
                            size="200x"
                            className="card-img rounded-0"
                        />
                    </div>
                </div>
                </Card>
            </Col>
            ))}
        </Row>

        {/* Bootstrap Modal */}
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
            <Modal.Title>{activeTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="ratio ratio-16x9">
                {activeVideoId && (
                <iframe
                    loading='lazy'
                    src={`https://www.youtube.com/embed/${activeVideoId}?autoplay=1`}
                    title="YouTube video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
                )}
            </div>
            </Modal.Body>
        </Modal>
        </Container>
    </section>
  );
}
